/* ============================================================
   BUY'NBYE — Live cart drawer refresh
   Upgrades the theme's placeholder refresh so add-to-cart and
   quantity changes update the drawer without a full page reload,
   using Shopify's Section Rendering API.
   ============================================================ */
(function () {
  function refreshCartDrawer() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var incoming = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('shopify-section-cart-drawer');
        var wrapper = document.getElementById('shopify-section-cart-drawer');
        if (wrapper && incoming) wrapper.innerHTML = incoming.innerHTML;
      })
      .catch(function () { /* ignore network/render errors */ });
  }

  // Replace the theme's no-op refresh (buynbye.js defines it globally).
  window.refreshCartDrawer = refreshCartDrawer;

  // The drawer's close button lives inside the re-rendered section, so bind
  // it with delegation to keep it working after every refresh.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-cart-close]')) {
      if (typeof window.closeCart === 'function') window.closeCart();
    }
  });
})();
